import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@mui/material";
import Box from "@mui/material/Box";
import { enqueueSnackbar } from "notistack";
import React, { ReactElement, useState } from "react";

import { Asset } from "../../../generated/gql/graphql";
import useAsset from "../../../hooks/mutation/assets/use-asset";

type Props = {
  isOpen: boolean;
  asset: Asset;
  onClose(): void;
};

export default function EditAssetDialog(props: Props): ReactElement {
  const { isOpen, asset, onClose } = props;

  const { updateAsset } = useAsset();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [name, setName] = useState(asset.name);

  async function onSave(): Promise<void> {
    if (!asset.id || isSubmitting) {
      return;
    }

    setIsSubmitting(true);
    try {
      await updateAsset(asset.id, {
        name: name,
      });
      onClose();
    } catch (error) {
      console.error(error);
      enqueueSnackbar("Failed to update asset name", { variant: "error" });
    } finally {
      setIsSubmitting(false);
    }
  }

  return (
    <Dialog open={isOpen} onClose={onClose}>
      <DialogTitle>Change asset name</DialogTitle>
      <DialogContent className="min-w-[300px]">
        <TextField
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            setName(e.target.value)
          }
          autoFocus
          focused
          margin="dense"
          type="text"
          fullWidth
          variant="standard"
          placeholder="Enter asset name"
          defaultValue={name}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button disabled={!name?.replace(/\s/g, "").length} onClick={onSave}>
          {isSubmitting ? (
            <Box className="text-center">
              <CircularProgress size="1rem" className="w-1 h-1" />
            </Box>
          ) : (
            <span>Save</span>
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
